import React from 'react'

// This is used to wrap non-input elements within a ReactAdmin form.
// Its purpose is to cancel the unwanted props that the form may force on the non-field content.
// Inspired by https://github.com/marmelab/react-admin/issues/4209

export const NonInput = ({ children }: React.PropsWithChildren<Record<string, unknown>>) => (
  <>{children}</>
)
